var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_426_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 7.9165C16.625 13.4582 9.5 18.2082 9.5 18.2082C9.5 18.2082 2.375 13.4582 2.375 7.9165C2.375 6.02684 3.12567 4.21456 4.46186 2.87837C5.79806 1.54217 7.61033 0.791504 9.5 0.791504C11.3897 0.791504 13.2019 1.54217 14.5381 2.87837C15.8743 4.21456 16.625 6.02684 16.625 7.9165Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.2915C10.8117 10.2915 11.875 9.22818 11.875 7.9165C11.875 6.60483 10.8117 5.5415 9.5 5.5415C8.18832 5.5415 7.125 6.60483 7.125 7.9165C7.125 9.22818 8.18832 10.2915 9.5 10.2915Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e3d357ea9621a15b95c192c10f73a6d7.svg";
export { ForwardRef as ReactComponent };